import { render, staticRenderFns } from "./ListaRecolhivel.vue?vue&type=template&id=08363a1c&scoped=true"
import script from "./ListaRecolhivel.vue?vue&type=script&lang=js"
export * from "./ListaRecolhivel.vue?vue&type=script&lang=js"
import style0 from "./ListaRecolhivel.vue?vue&type=style&index=0&id=08363a1c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08363a1c",
  null
  
)

export default component.exports